var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"console-dashboard"},[_c('div',{staticClass:"erp-list-task leiloeiros-list"},[_c('arrematantes',{attrs:{"title":"Leiloeiro","list-storage-prop":_vm.listStorage,"list-storage-name":_vm.listName}})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }